module.exports = "<div class=\"loans-detail-finish-deadline\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p>{{ $ctrl.loan.detail.finishDeadline | translate }}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailFinishDeadline/loansDetailFinishDeadline.html
// module id = 1872
// module chunks = 0